export function isHieroglyphs(nameString: string | null): boolean {
  if (!nameString) {
    return false;
  }

  const hieroglyphs = /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}]+/gu;
  const hieroglyphsRange =
    /([^(A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s&-\\"0-9\\.,—]{2,})/gm;
  const hieroglyphsTest: boolean = hieroglyphs.test(nameString);
  const hieroglyphsRangeTest: boolean = hieroglyphsRange.test(nameString);

  return hieroglyphsTest || hieroglyphsRangeTest;
}
